// ============================================================================
// INITIAL STATE - componentLibraryInitialState.js
// ============================================================================
// ./context/componentLibrary/componentLibraryInitialState.js


import { CourseDomains } from '../../types/courseDomains';

// Collect all unique category keys across all domains and canvases
const allCategoryKeys = [
  ...new Set(
    Object.values(CourseDomains)
      .flatMap(domain => domain.canvases)
      .flatMap(canvas => canvas.categories)
      .map(cat => cat.key)
  )
];

const componentsByCategory = Object.fromEntries(
  allCategoryKeys.map(key => [key, []])
);

export default {
  components: [],
  currentComponent: null,
  componentsByCategory,
  searchResults: [],
  bulkImport: {
    isChecking: false,
    isImporting: false,
    duplicates: [],
    importResult: null
  },
  isLoading: false,
  error: null
};